import React from 'react';
import PropTypes from 'prop-types';

//------------------------------------------------------------------------------

const InputHidden = ({ id, value, onChange }) =>
  <input type="hidden" id={id} name={id} value={value} onChange={onChange} />;

InputHidden.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

InputHidden.defaultProps = {
  value: undefined,
  onChange: null,
};

export default InputHidden;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select/InputHidden/index.js